import { List, Typography } from "@mui/material";
import Companies from "../components/admin/modals/Companies";
import Offices from "../components/admin/modals/Offices";
import Users from "../components/admin/modals/Users";
import AppModules from "../components/admin/modals/AppModules";

const AdminPanel = () => {
    return (
        <>
            <Typography variant="h4">Admin Panel</Typography>
            <List>
                <Users />
                <Companies />
                <Offices />
                <AppModules />
            </List>
        </>
    );
};

export default AdminPanel;
